import { cilReferral } from "src/assets/icons/cilReferral/cilReferral";
import { SIDEBAR_CONSTANTS } from "src/constants/sidebarConstants";
import { locales } from "src/locales/indexLocales";
import { invoiceLocales } from "src/locales/invoice.locales";
import { jobLocales } from "src/locales/jobLocales";
import { payRangeLocales } from "src/locales/payRange.locales";
import { SidebarItem } from "src/models/common.model";

import {
  cilAccountLogout,
  cilAvTimer,
  cilBell,
  cilBriefcase,
  cilCalendar,
  cilDollar,
  cilGroup,
  cilHospital,
  cilLibrary,
  cilMoney,
  cilNotes,
  cilSettings,
  cilSpeedometer,
  cilSpreadsheet,
  cilUser,
} from "@coreui/icons";

const sidebarItems: SidebarItem[] = [
  {
    label: SIDEBAR_CONSTANTS.FIRST_ROW,
    icon: cilSpeedometer,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.ROUTE_DASHBOARD,
    },
  },
  {
    label: SIDEBAR_CONSTANTS.SECOND_ROW,
    icon: cilHospital,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.ROUTE_OFFICE_USERS,
    },
    moduleId: SIDEBAR_CONSTANTS.MODULE_ID.OFFICES,
  },
  {
    label: SIDEBAR_CONSTANTS.THIRD_ROW,
    icon: cilUser,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.ROUTE_PROFESSIONAL_USERS,
    },
    moduleId: SIDEBAR_CONSTANTS.MODULE_ID.PROFESSIONALS,
  },
  {
    label: SIDEBAR_CONSTANTS.FOURTH_ROW,
    icon: cilBriefcase,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.ROUTE_JOB,
    },
    moduleId: SIDEBAR_CONSTANTS.MODULE_ID.JOBS,
    children: [
      {
        label: jobLocales.masterList,
        action: {
          route: SIDEBAR_CONSTANTS.ROUTE_JOB,
          type: "link",
        },
        icon: ["cil-list"],
      },
      {
        label: jobLocales.assignments,
        action: {
          route: SIDEBAR_CONSTANTS.ROUTE_JOB_ASSIGNMENTS,
          type: "link",
        },
        icon: ["cil-list"],
      },
      {
        label: jobLocales.cancelled,
        action: {
          route: SIDEBAR_CONSTANTS.ROUTE_JOB_CANCELLED,
          type: "link",
        },
        icon: ["cil-list"],
      },
    ],
  },
  {
    label: invoiceLocales.invoice,
    icon: cilDollar,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.ROUTE_INVOICE,
    },
    moduleId: SIDEBAR_CONSTANTS.INVOICE,
    children: [
      {
        label: "Weekly List",
        action: {
          route: "/admin/invoice",
          type: "link",
        },
        icon: ["cil-list"],
      },
      {
        label: "Master List",
        action: {
          route: "/admin/invoice-list",
          type: "link",
        },
        icon: ["cil-list"],
      },
    ],
  },
  {
    label: SIDEBAR_CONSTANTS.PROSPECTS,
    icon: cilBriefcase,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.ROUTE_PROSPECTS,
    },
    moduleId: SIDEBAR_CONSTANTS.MODULE_ID.PROSPECTS,
  },
  {
    label: SIDEBAR_CONSTANTS.FIFTH_ROW,
    icon: cilBriefcase,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.ROUTE_APPLICATION,
    },
    moduleId: SIDEBAR_CONSTANTS.MODULE_ID.APPLICATIONS,
  },
  {
    label: SIDEBAR_CONSTANTS.THIRTEENTH_ROW,
    icon: cilSettings,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.ROUTE_SETTINGS,
    },
    superAdminOnly: true,
  },
  {
    label: SIDEBAR_CONSTANTS.STATEMENT,
    icon: cilSettings,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.ROUTE_STATEMENT,
    },
  },
  {
    label: locales.notesLabel,
    icon: cilNotes,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.ROUTE_NOTES,
    },
    moduleId: SIDEBAR_CONSTANTS.MODULE_ID.NOTES,
  },
  {
    label: locales.roleLabel,
    icon: cilGroup,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.ROLE_MANAGEMENT,
    },
    moduleId: SIDEBAR_CONSTANTS.MODULE_ID.ROLE_MANAGEMENT,
  },
  {
    label: SIDEBAR_CONSTANTS.EIGHTH_ROW,
    icon: cilLibrary,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.ROUTE_TABS,
    },
    moduleId: SIDEBAR_CONSTANTS.MODULE_ID.CATEGORY_MANAGEMENT,
  },
  {
    label: locales.referral,
    icon: cilReferral,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.REFERRAL_ROUTE,
    },
    moduleId: SIDEBAR_CONSTANTS.MODULE_ID.CATEGORY_MANAGEMENT,
  },
  {
    label: SIDEBAR_CONSTANTS.NINTH_ROW,
    icon: cilAvTimer,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.TIMESHEET_ROUTE,
    },
    moduleId: SIDEBAR_CONSTANTS.MODULE_ID.TIMESHEETS,
  },
  {
    label: SIDEBAR_CONSTANTS.PAY_RANGE_AND_BILL_RATES,
    icon: cilMoney,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.PAY_RANGE_AND_BILL_RATES_URL,
    },
    moduleId: SIDEBAR_CONSTANTS.MODULE_ID.PAY_RANGE_AND_BILL_RATES,
    children: [
      {
        label: payRangeLocales.standardPricing,
        action: {
          route: SIDEBAR_CONSTANTS.PAY_RANGE_STANDARD_PRICING_URL,
          type: "link",
        },
        icon: ["cil-list"],
      },
      {
        label: payRangeLocales.transparencyModel,
        action: {
          route: SIDEBAR_CONSTANTS.PAY_RANGE_TRANSPARENCY_MODEL_URL,
          type: "link",
        },
        icon: ["cil-list"],
      },
      {
        label: payRangeLocales.referralJob,
        action: {
          route: SIDEBAR_CONSTANTS.PAY_RANGE_REFERRAL_JOB_URL,
          type: "link",
        },
        icon: ["cil-list"],
      },
    ],
  },

  {
    label: SIDEBAR_CONSTANTS.NOTIFICATION,
    icon: cilBell,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.NOTIFICATION_URL,
    },
    moduleId: SIDEBAR_CONSTANTS.MODULE_ID.NOTIFICATIONS,
  },
  {
    label: SIDEBAR_CONSTANTS.ELEVENTH_ROW,
    icon: cilCalendar,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.CALANDER_ROUTE,
    },
    moduleId: SIDEBAR_CONSTANTS.MODULE_ID.CALENDAR,
  },
  {
    label: locales.reports,
    icon: cilSpreadsheet,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.REPORT_ROUTE,
    },
    moduleId: SIDEBAR_CONSTANTS.MODULE_ID.CALENDAR,
  },
  {
    label: SIDEBAR_CONSTANTS.REVENUE_REPORT,
    icon: cilMoney,
    action: {
      type: "route",
      route: SIDEBAR_CONSTANTS.REVENUE_REPORT_URL,
    },
    moduleId: SIDEBAR_CONSTANTS.MODULE_ID.REVENUE_REPORT,
  },
  {
    label: SIDEBAR_CONSTANTS.FOURTEENTH_ROW,
    icon: cilAccountLogout,
    action: {
      type: "logout",
    },
  },
];

export default sidebarItems;
